'use client';
'use strict';

var classes = {"root":"m-e5262200","indicator":"m-760d1fb1","processing":"m-885901b1"};

module.exports = classes;
//# sourceMappingURL=Indicator.module.css.cjs.map
